const LargeCloseIcon = () => {
  return (
    <svg width='32' height='33' viewBox='0 0 32 33' fill='none'>
      <path
        d='M24 8.87427L8 24.958M8 8.87427L24 24.958'
        stroke='#41415A'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LargeCloseIcon;
